import React from 'react';
import { Redirect } from 'react-router-dom';
import { PageTitle } from '../PageTitle';
import { Message } from '../Message';
import QuickLinkForm from './quick_link_form';
import QuickLinksService from '../../services/quick_links_service';

class QuickLinkEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            quickLinkId: props.match.params.quickLinkId,
            quickLink: null,
            updated: false,
            deleted: false,
            successMessage: null,
            localErrorMessage: null
        };
    }

    componentDidMount() {
        QuickLinksService.getAll().then(response => {
            const quickLink = response.quickLinks.find(ql => String(ql.id) === String(this.state.quickLinkId));
            if (quickLink) {
                this.setState({ quickLink });
            } else {
                this.setState({ localErrorMessage: 'Quick link not found.' });
            }
        }).catch(error => {
            console.error(error);
            this.setState({ localErrorMessage: 'Could not load quick link for editing.' });
        });
    }

    handleSubmit(quickLink) {
        QuickLinksService.save(quickLink, this.state.quickLinkId).then(() => {
            this.setState({ updated: true, successMessage: 'Quick link updated.' });
        }).catch(error => {
            console.error(error);
            this.setState({ localErrorMessage: error.message });
        });
    }

    handleDelete() {
        QuickLinksService.delete(this.state.quickLinkId).then(() => {
            this.setState({ deleted: true, successMessage: 'Quick link deleted.' });
        }).catch(error => {
            console.error(error);
            this.setState({ localErrorMessage: error.message });
        });
    }

    messageDismissCallback() {
        this.setState({ localErrorMessage: null });
    }

    renderMessages() {
        if (this.state.localErrorMessage) {
            return (
                <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
            );
        }
        return null;
    }

    render() {
        if (this.state.updated || this.state.deleted) {
            return (
                <Redirect to={{
                    pathname: '/admin-admin/quick-links',
                    state: { from: this.props.location, successMessage: this.state.successMessage }
                }} />
            );
        }

        if (!this.state.quickLink) {
            return this.state.localErrorMessage
                ? <div>{this.renderMessages()}</div>
                : <div className="loader">Loading...</div>;
        }

        return (
            <div>
                <div className="row">
                    <PageTitle title="Edit Quick Link" />
                </div>
                {this.renderMessages()}
                <div className="row">
                    <QuickLinkForm
                        quickLink={this.state.quickLink}
                        onSubmit={this.handleSubmit.bind(this)}
                        onDelete={this.handleDelete.bind(this)}
                    />
                </div>
            </div>
        );
    }
}

export default QuickLinkEdit;
